module.exports = __webpack_public_path__ + "assets/img/rotate-dark.d4861fea.svg";